// src/data/languages/yoruba/categories/sentencesgap.ts
//
// Phrases à trous pour la révision en yoruba. Chaque clé reprend une clé
// de grammaire.ts : le mot-clé doit apparaître tel quel (mot séparé par
// des espaces) dans `original`, c'est lui qui sera masqué.

import { RevisionSentenceCollection } from '../../../../types/types';

export const sentencesgap: RevisionSentenceCollection = {
  // ── Adjectifs — Les goûts ──
  "korò": [
    { original: "Àgbo yẹn korò", french: "Cette tisane (àgbo) est amère", english: "That herbal drink (àgbo) is bitter", audio: "Yo-Agbo_yen_koro" }
  ],
  "le": [
    { original: "Iyán tí mo rà le", french: "L’igname pilée que j’ai achetée était dure", english: "The pounded yam I bought was hard", audio: "Yo-Iyan_ti_mo_ra_le" }
  ],
  // ── Pronoms sujets ──
  "Mo": [
    { original: "Mo ń bọ ẹran", french: "Je fais bouillir de la viande", english: "I am boiling meat", audio: "Yo-Mo_n_bo_eran" },
    { original: "Mo ń jẹun", french: "Je mange", english: "I am eating" },
    { original: "Mo fẹ́ omi", french: "Je veux de l'eau", english: "I want water" },
    { original: "Mo ti dé", french: "Je suis arrivé(e)", english: "I have arrived" }
  ],
  "O": [
    { original: "O ń wẹ̀ l’ọ́wọ́", french: "Tu es en train de te laver", english: "You are washing", audio: "Yo-O_n_we_lowo" },
    { original: "O ń ṣiṣẹ́", french: "Tu travailles", english: "You are working" },
    { original: "O ti jẹun", french: "Tu as mangé", english: "You have eaten" },
    { original: "O fẹ́ lọ sí ọjà", french: "Tu veux aller au marché", english: "You want to go to the market" }
  ],
  "Ó": [
    { original: "Ó ti fẹ́ jáde", french: "Il / Elle est sur le point de sortir", english: "He / She is about to go out", audio: "Yo-O_ti_fe_jade" },
    { original: "Ó ń sùn", french: "Il/Elle dort", english: "He/She is sleeping" },
    { original: "Ó ti lọ", french: "Il/Elle est parti(e)", english: "He/She has left" },
    { original: "Ó dára", french: "C'est bien", english: "It is good" }
  ],
  "A": [
    { original: "A padà wá s’ílé", french: "Nous sommes rentrés à la maison", english: "We came back home", audio: "Yo-A_pada_wa_sile" },
    { original: "A san owó púpọ̀", french: "Nous avons payé beaucoup d’argent", english: "We paid a lot of money", audio: "Yo-A_san_owo_pupo" },
    { original: "A ń kàwé", french: "Nous étudions", english: "We are studying" },
    { original: "A ti dé", french: "Nous sommes arrivés", english: "We have arrived" },
    { original: "A fẹ́ jẹun", french: "Nous voulons manger", english: "We want to eat" }
  ],
  "Ẹ": [
    { original: "Ṣé ẹ ma rà á fún wa?", french: "Vous allez nous l’acheter ?", english: "Are you going to buy it for us?", audio: "Yo-Se_e_ma_ra_a_fun_wa", testWord: "ẹ" },
    { original: "Ẹ ò lọ mọ́", french: "Vous n’y allez plus", english: "You no longer go there", audio: "Yo-E_o_lo_mo" },
    { original: "Ẹ ń sọ̀rọ̀", french: "Vous parlez", english: "You are talking" },
    { original: "Ẹ jókòó", french: "Asseyez-vous", english: "Please sit down" },
    { original: "Ẹ ti dé", french: "Vous voilà (bienvenue)", english: "You have arrived (welcome)" }
  ],
  "Wọ́n": [
    { original: "Wọ́n fún (à)wa ní ẹ̀bùn", french: "Ils nous ont offert un cadeau", english: "They gave us a gift", audio: "Yo-Won_fun_awa_ni_ebun" },
    { original: "Wọ́n jẹ gbogbo ẹ̀ tán", french: "Ils ont tout mangé", english: "They ate it all", audio: "Yo-Won_je_gbogbo_e_tan" },
    { original: "Wọ́n ń jó", french: "Ils/Elles dansent", english: "They are dancing" },
    { original: "Wọ́n ti lọ", french: "Ils/Elles sont parti(e)s", english: "They have left" },
    { original: "Wọ́n ń ṣeré", french: "Ils/Elles jouent", english: "They are playing" }
  ],

  // ── Pronoms emphatiques ──
  "Èmi": [
    { original: "Èmi àti Bọ́lá pàdé", french: "Bola et moi nous sommes rencontrés", english: "Bola and I met", audio: "Yo-Emi_ati_Bola_pade" },
    { original: "Èmi ni Adé", french: "C'est moi, Adé", english: "I am Adé" },
    { original: "Èmi yóò lọ", french: "J'irai", english: "I will go" },
    { original: "Èmi kò mọ̀", french: "Moi, je ne sais pas", english: "I don't know" }
  ],
  "Ìwọ": [
    { original: "Ìwọ ń kọ́?", french: "Et toi ?", english: "And you?", audio: "Yo-Iwo_n_ko" },
    { original: "Ìwọ ńkọ́?", french: "Et toi ?", english: "And you?" },
    { original: "Ìwọ ni mo ń wá", french: "C'est toi que je cherche", english: "It's you I'm looking for" }
  ],

  // ── Pronoms possessifs autonomes (le mien, le tien…) ──
  "T’èmi": [
    { original: "T’èmi ni", french: "C’est à moi", english: "It’s mine", audio: "Yo-Temi_ni" }
  ],
  "T’ìwọ": [
    { original: "T’ìwọ nìyẹn", french: "C’est à toi", english: "That’s yours", audio: "Yo-Tiwo_niyen" }
  ],
  "T’òun": [
    { original: "T’òun kọ́", french: "Ce n’est pas à lui / à elle", english: "It’s not his / hers", audio: "Yo-Toun_ko" }
  ],
  "T’àwa": [
    { original: "T’àwa l’èyí", french: "Ceci est à nous", english: "This is ours", audio: "Yo-Tawa_leyi" }
  ],
  "T’ẹ̀yin": [
    { original: "T’ẹ̀yin ni", french: "C’est à vous", english: "It’s yours", audio: "Yo-Teyin_ni" }
  ],
  "T’àwọn": [
    { original: "T’àwọn kọ́", french: "Ce n’est pas à eux", english: "It’s not theirs", audio: "Yo-Tawon_ko" }
  ],

  // ── Pronoms emphatiques (phrases enregistrées) ──
  "Òun": [
    { original: "Òun ló ní i", french: "C’est à lui / à elle", english: "It’s his / hers", audio: "Yo-Oun_lo_ni_i" }
  ],
  "Ẹ̀yin": [
    { original: "Ẹ̀yin ni mo sọ fún", french: "C’est à vous que je l’ai dit", english: "It’s you I told", audio: "Yo-Eyin_ni_mo_so_fun" }
  ],

  // ── Possessifs ──
  "mi": [
    { original: "Orúkọ mi ni Adé", french: "Je m'appelle Adé", english: "My name is Adé" },
    { original: "Ilé mi tóbi", french: "Ma maison est grande", english: "My house is big" },
    { original: "Bàbá mi ń ṣiṣẹ́", french: "Mon père travaille", english: "My father is working" }
  ],
  "rẹ": [
    { original: "Kí ni orúkọ rẹ?", french: "Comment t'appelles-tu ?", english: "What is your name?" },
    { original: "Ìyá rẹ ń bọ̀", french: "Ta mère arrive", english: "Your mother is coming" },
    { original: "Aṣọ rẹ lẹ́wà", french: "Ton vêtement est beau", english: "Your clothes are beautiful" }
  ],
  "rẹ̀": [
    { original: "Ọmọ rẹ̀ kéré", french: "Son enfant est petit", english: "His/Her child is small" },
    { original: "Ọkọ rẹ̀ ga", french: "Son mari est grand", english: "Her husband is tall" },
    { original: "Ìwé rẹ̀ wà lórí tábìlì", french: "Son livre est sur la table", english: "His/Her book is on the table" }
  ],
  "wa": [
    { original: "Ìlú wa lẹ́wà", french: "Notre ville est belle", english: "Our town is beautiful" },
    { original: "Ilé wa wà ní Èkó", french: "Notre maison est à Lagos", english: "Our house is in Lagos" },
    { original: "Olùkọ́ wa ti dé", french: "Notre professeur est arrivé", english: "Our teacher has arrived" }
  ],
  "yín": [
    { original: "Kí ni orúkọ yín?", french: "Comment vous appelez-vous ?", english: "What is your name? (polite)" },
    { original: "Ilé yín jìnà", french: "Votre maison est loin", english: "Your house is far" },
    { original: "Ọmọ yín dára", french: "Votre enfant est sage", english: "Your child is good" }
  ],
  "wọn": [
    { original: "Ilé wọn tóbi", french: "Leur maison est grande", english: "Their house is big" },
    { original: "Bàbá wọn ti dé", french: "Leur père est arrivé", english: "Their father has arrived" },
    { original: "Ọmọ wọn ń ṣeré", french: "Leur enfant joue", english: "Their child is playing" }
  ],

  // ── Démonstratifs ──
  "yìí": [
    { original: "Ilé yìí tóbi", french: "Cette maison est grande", english: "This house is big" },
    { original: "Oúnjẹ yìí dùn", french: "Ce plat est délicieux", english: "This food is delicious" },
    { original: "Omi yìí tutù", french: "Cette eau est fraîche", english: "This water is cold" }
  ],
  "náà": [
    { original: "Ìwé náà dára", french: "Le livre est bien", english: "The book is good" },
    { original: "Ọkọ̀ náà ti dé", french: "Le véhicule est arrivé", english: "The vehicle has arrived" },
    { original: "Ọmọ náà ń sùn", french: "L'enfant dort", english: "The child is sleeping" }
  ],

  // ── Temps verbaux ──
  "ń": [
    { original: "Mo ń lọ sí ọjà", french: "Je vais au marché", english: "I am going to the market" },
    { original: "Ó ń sunkún", french: "Il/Elle pleure", english: "He/She is crying" },
    { original: "Ìyá ń se oúnjẹ", french: "Maman prépare à manger", english: "Mother is cooking" }
  ],
  "ti": [
    { original: "Mo ti jẹun", french: "J'ai déjà mangé", english: "I have eaten" },
    { original: "Ó ti sùn", french: "Il/Elle s'est endormi(e)", english: "He/She has fallen asleep" },
    { original: "Wọ́n ti dé", french: "Ils/Elles sont arrivé(e)s", english: "They have arrived" }
  ],
  "máa": [
    { original: "Ó máa wá ní ọ̀la", french: "Il/Elle viendra demain", english: "He/She will come tomorrow" },
    { original: "A máa lọ", french: "Nous irons", english: "We will go" },
    { original: "Mo máa ń jí ní àárọ̀", french: "Je me réveille d'habitude le matin", english: "I usually wake up in the morning" }
  ],
  "yóò": [
    { original: "Èmi yóò lọ", french: "J'irai", english: "I will go" },
    { original: "Àwa yóò jẹun", french: "Nous mangerons", english: "We will eat" }
  ],

  // ── Négation ──
  "kò": [
    { original: "Kò sí", testWord: "Kò", french: "Il n'y en a pas", english: "There is none" },
    { original: "Bàbá kò sí nílé", french: "Papa n'est pas à la maison", english: "Father is not at home" },
    { original: "Kò dára", testWord: "Kò", french: "Ce n'est pas bien", english: "It is not good" }
  ],
  "ò": [
    { original: "Mi ò mọ̀", french: "Je ne sais pas", english: "I don't know" },
    { original: "Mi ò fẹ́", french: "Je ne veux pas", english: "I don't want" },
    { original: "Ara mi ò yá", french: "Je ne me sens pas bien", english: "I don't feel well" }
  ],
  "Màá": [
    { original: "Màá gbìyànjú", testWord: "Màá", french: "J’essaierai", english: "I will try", audio: "Yo-Maa_gbiyanju" },
    { original: "Mo màá gbìyànjú", testWord: "màá", french: "J’essaierai", english: "I will try", audio: "Yo-Mo_maa_gbiyanju" },
    { original: "Màá nà ẹ", testWord: "Màá", french: "Je vais te frapper", english: "I'm going to hit you", audio: "Yo-Maa_na_e" },
    { original: "Màá s’oúnje", testWord: "Màá", french: "Je vais cuisiner", english: "I'm going to cook", audio: "Yo-Maa_sounje" }
  ],
  "má": [
    { original: "Má lọ", testWord: "Má", french: "Ne pars pas", english: "Don't go", audio: "Yo-Ma_lo" },
    { original: "Má ṣé e", testWord: "Má", french: "Ne le fais pas", english: "Don't do it", audio: "Yo-Ma_se_e" },
    { original: "Má gbàgbé", testWord: "Má", french: "N’oublie pas", english: "Don't forget", audio: "Yo-Ma_gbagbe" },
    { original: "Má jáde", testWord: "Má", french: "Ne sors pas", english: "Don't go out", audio: "Yo-Ma_jade" },
    { original: "Má ké", testWord: "Má", french: "Ne pleure pas", english: "Don't cry", audio: "Yo-Ma_ke" },
    { original: "Má sọ̀rọ̀", testWord: "Má", french: "Ne parle pas", english: "Don't talk" },
    { original: "Ẹ má bínú", french: "Ne vous fâchez pas (désolé)", english: "Don't be angry (sorry)" }
  ],

  // ── Questions ──
  "Ṣé": [
    { original: "Ṣé o ti jẹun?", french: "As-tu mangé ?", english: "Have you eaten?" },
    { original: "Ṣé àlàáfíà ni?", french: "Tu vas bien ?", english: "Are you well?" },
    { original: "Ṣé o gbọ́ Yorùbá?", french: "Tu comprends le yoruba ?", english: "Do you understand Yoruba?" }
  ],
  "Níbo": [
    { original: "Níbo ni ọjà wà?", french: "Où est le marché ?", english: "Where is the market?" },
    { original: "Níbo ni o ń lọ?", french: "Où vas-tu ?", english: "Where are you going?" },
    { original: "Níbo ni o ń gbé?", french: "Où habites-tu ?", english: "Where do you live?" }
  ],
  "Báwo": [
    { original: "Báwo ni?", french: "Comment ça va ?", english: "How are you?" },
    { original: "Báwo ni iṣẹ́?", french: "Comment va le travail ?", english: "How is work?" },
    { original: "Báwo ni ilé?", french: "Comment va la famille ?", english: "How is the family?" }
  ],
  "Èló": [
    { original: "Èló ni èyí?", french: "Combien coûte ceci ?", english: "How much is this?" },
    { original: "Èló ni ẹja yìí?", french: "Combien coûte ce poisson ?", english: "How much is this fish?" }
  ],

  // ── Prépositions ──
  "ní": [
    { original: "Mo wà ní ọjà", french: "Je suis au marché", english: "I am at the market" },
    { original: "Ó ń gbé ní Èkó", french: "Il/Elle habite à Lagos", english: "He/She lives in Lagos" }
  ],
  "sí": [
    { original: "Mo ń lọ sí ilé", french: "Je rentre à la maison", english: "I am going home" },
    { original: "Ó lọ sí Ìbàdàn", french: "Il/Elle est allé(e) à Ibadan", english: "He/She went to Ibadan" },
    { original: "A ń lọ sí ọjà", french: "Nous allons au marché", english: "We are going to the market" }
  ],
  "lórí": [
    { original: "Ìwé wà lórí tábìlì", french: "Le livre est sur la table", english: "The book is on the table" },
    { original: "Jókòó lórí àga", french: "Assieds-toi sur la chaise", english: "Sit on the chair" }
  ],
  "nínú": [
    { original: "Omi wà nínú ìgò", french: "L'eau est dans la bouteille", english: "The water is in the bottle" },
    { original: "Ọbẹ̀ wà nínú ìkòkò", french: "La sauce est dans la marmite", english: "The stew is in the pot" }
  ],
  "pẹ̀lú": [
    { original: "Mo lọ pẹ̀lú ọ̀rẹ́ mi", french: "Je suis allé(e) avec mon ami(e)", english: "I went with my friend" },
    { original: "Wá pẹ̀lú mi", french: "Viens avec moi", english: "Come with me" },
    { original: "Ó ń jẹun pẹ̀lú ìyá rẹ̀", french: "Il/Elle mange avec sa mère", english: "He/She is eating with his/her mother" }
  ],

  // ── Conjonctions et adverbes ──
  "àti": [
    { original: "Ìyá àti bàbá", french: "Maman et papa", english: "Mother and father" },
    { original: "Mo ra ẹja àti ẹran", french: "J'ai acheté du poisson et de la viande", english: "I bought fish and meat" }
  ],
  "ṣùgbọ́n": [
    { original: "Mo fẹ́ lọ ṣùgbọ́n ó ti pẹ́", french: "Je veux partir mais il est tard", english: "I want to go but it's late" }
  ],
  "púpọ̀": [
    { original: "Ẹ ṣé púpọ̀", french: "Merci beaucoup", english: "Thank you very much" },
    { original: "Ó jẹun púpọ̀", french: "Il/Elle a beaucoup mangé", english: "He/She ate a lot" }
  ],
  "dáadáa": [
    { original: "Mo wà dáadáa", french: "Je vais bien", english: "I am well" },
    { original: "Ó ń kọrin dáadáa", french: "Il/Elle chante bien", english: "He/She sings well" }
  ]
};

export default sentencesgap;
